/*
  Bewegende hero.

  De video staat in de Liquid in een <template>, zodat de browser hem pas
  ophaalt als hier wordt besloten dat het mag. Dat scheelt een telefoon een
  bestand van een paar megabyte dat hij toch niet te zien krijgt.

  Overslaan gebeurt bij: bewegingsvoorkeur uit, smal scherm terwijl mobiel niet
  is aangezet, of een verbinding die de browser zelf als traag of beperkt meldt.
  In al die gevallen blijft het achtergrondbeeld staan, en dat is precies de
  eerste frame van de video.
*/
(function () {
  function magHijSpelen(houder) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;

    var opMobiel = houder.getAttribute('data-op-mobiel') === 'true';
    if (!opMobiel && window.matchMedia('(max-width: 749px)').matches) return false;

    var verbinding = navigator.connection;
    if (verbinding) {
      if (verbinding.saveData) return false;
      if (/^(slow-2g|2g|3g)$/.test(verbinding.effectiveType || '')) return false;
    }

    return true;
  }

  function start(houder) {
    var sjabloon = houder.querySelector('template');
    if (!sjabloon) return;

    houder.appendChild(sjabloon.content.cloneNode(true));
    sjabloon.remove();

    var video = houder.querySelector('video');
    if (!video) return;

    /* Sommige browsers weigeren autoplay zonder deze twee expliciet gezet. */
    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;

    /* Pas zichtbaar maken als er echt beeld is, anders flitst er zwart. */
    function toon() {
      houder.classList.add('is-actief');
    }
    if (video.readyState >= 3) {
      toon();
    } else {
      video.addEventListener('canplay', toon, { once: true });
    }

    video.preload = 'auto';
    var poging = video.play();
    if (poging && typeof poging.catch === 'function') {
      /* Lukt autoplay niet, dan blijft het beeld staan. Geen foutmelding waard. */
      poging.catch(function () {});
    }
  }

  function init() {
    document.querySelectorAll('[data-lez-hero-video]').forEach(function (houder) {
      if (houder.dataset.lezGestart) return;
      houder.dataset.lezGestart = '1';
      if (magHijSpelen(houder)) start(houder);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* De thema-editor bouwt secties opnieuw op. */
  document.addEventListener('shopify:section:load', init);
})();
